<template>
  <pf-grid>
    <wizard-summary-option
      :name="$t('Firewall')"
      :value="wizard.addOnFirewall ? $t('Dedicato') : $t('A bordo del server')"
      edit-step="WizardStepProdottiInfrastruttura"
      ouia-id="wizard-summary-firewall-attivazione"
    />
    <template v-if="wizard.addOnFirewall && wizard.path === 'cloud'">
      <wizard-summary-option :name="$t('Risorse')" ouia-id="wizard-summary-firewall-risorse">
        {{ wizard.cpuFirewallQt }} <cpu-icon title="cpu" /> {{ wizard.ramFirewallQt }} GB <memory-icon title="ram" /> {{ wizard.storageFirewallQt }} GB
        <volume-icon title="storage" />
      </wizard-summary-option>
      <wizard-summary-option :name="$t('Sistema operativo')" value="OPNSense" ouia-id="wizard-summary-firewall-os" />
    </template>
  </pf-grid>
</template>

<script lang="ts" setup>
import WizardSummaryOption from './wizard-summary-option.vue';
import CpuIcon from '@vue-patternfly/icons/cpu-icon';
import MemoryIcon from '@vue-patternfly/icons/memory-icon';
import VolumeIcon from '@vue-patternfly/icons/volume-icon';
import { useWizard } from '@/wizard';

const wizard = useWizard();
</script>
